import { useState } from "react";
import { Edit2, Plus } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { GlobalCategoryDeleteAction } from "./GlobalCategoryDeleteAction";

export const GlobalPictogramCategories = ({ categories, reload }) => {
  const [editing, setEditing] = useState(null);
  const [busy, setBusy] = useState(false);
  const save = async () => {
    if (!editing.name.trim()) return toast.error("Inserisci il nome della categoria.");
    setBusy(true);
    try {
      const body = { name: editing.name.trim(), order_index: Number(editing.order_index) || 0 };
      if (editing.id) await api.put(`/admin/pictogram-categories/${editing.id}`, body);
      else await api.post("/admin/pictogram-categories", body);
      setEditing(null); await reload(); toast.success("Categoria salvata");
    } catch (err) { toast.error(err.response?.data?.detail || "Impossibile salvare la categoria"); }
    finally { setBusy(false); }
  };
  return <section className="mb-12" data-testid="admin-picto-categories">
    <div className="flex flex-wrap justify-between items-center gap-3 border-b border-[#D4D4D4] pb-4 mb-5">
      <h2 className="font-serif text-2xl">Categorie</h2>
      <button type="button" onClick={() => setEditing({ name: "", order_index: categories.length })}
        className="btn-ghost inline-flex items-center gap-2" data-testid="admin-picto-new-category"><Plus className="w-4 h-4" />Nuova categoria</button>
    </div>
    {editing && <div className="grid grid-cols-1 sm:grid-cols-[1fr_110px_auto] gap-3 items-end bg-[#F4F4F0] p-4 mb-5" data-testid="admin-picto-category-form">
      <div><label htmlFor="admin-picto-category-name" className="label-tiny">Nome categoria</label>
        <input id="admin-picto-category-name" className="input-luxury w-full" maxLength={80} value={editing.name}
          onChange={e => setEditing({ ...editing, name: e.target.value })} data-testid="admin-picto-category-name" /></div>
      <div><label htmlFor="admin-picto-category-order" className="label-tiny">Ordine</label>
        <input id="admin-picto-category-order" type="number" className="input-luxury w-full" value={editing.order_index}
          onChange={e => setEditing({ ...editing, order_index: e.target.value })} data-testid="admin-picto-category-order" /></div>
      <div className="flex gap-2"><button type="button" disabled={busy} onClick={save} className="btn-primary" data-testid="admin-picto-category-save">Salva</button>
        <button type="button" disabled={busy} onClick={() => setEditing(null)} className="btn-ghost" data-testid="admin-picto-category-cancel">Annulla</button></div>
    </div>}
    {categories.length === 0 && <p className="text-sm text-[#707070] py-4" data-testid="admin-picto-categories-empty">Crea una categoria prima di caricare i pittogrammi.</p>}
    <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-3">
      {categories.map(c => <div key={c.id} className="border border-[#D4D4D4] bg-white p-4 flex flex-wrap items-center justify-between gap-3" data-testid={`admin-picto-category-${c.id}`}>
        <span className="font-serif text-lg break-words min-w-0" data-testid={`admin-picto-category-label-${c.id}`}>{c.name}</span>
        <div className="flex flex-wrap justify-end gap-2">
          <button type="button" title="Modifica categoria" aria-label={`Modifica ${c.name}`} onClick={() => setEditing(c)}
            className="btn-ghost !p-2" data-testid={`admin-picto-category-edit-${c.id}`}><Edit2 className="w-4 h-4" /></button>
          <GlobalCategoryDeleteAction category={c} reload={reload} />
        </div>
      </div>)}
    </div>
  </section>;
};